document.addEventListener("DOMContentLoaded", () => {
    jQuery(document).ready(function($) {
        /*
        * ARCHIVE DESCRIPTION
        * gestione della descrizione dell'archivio.
        * se è più lunga di 3 righe, mostro un pulsante per espandere la descrizione
        */
        const archiveDescription = document.querySelector('.archive-description')
        const archiveDescriptionShowMore = document.querySelector('.archive-description-show-more')
        const archiveDescriptionShowMoreText = document.querySelector('.archive-description-show-more-text')

        if (archiveDescription && archiveDescriptionShowMore) {
            const computedStyle = window.getComputedStyle(archiveDescription);
            const lineHeight = parseFloat(computedStyle.lineHeight);
            const maxLines = 3;
            const maxHeight = lineHeight * maxLines;

            if (archiveDescription.scrollHeight > maxHeight) {
                archiveDescriptionShowMore.classList.add('visible');
                archiveDescriptionShowMore.style.display = 'flex'; // Mostra il pulsante se il testo è lungo
            }

            archiveDescriptionShowMore.addEventListener('click', function () {
                if (archiveDescription.classList.contains('expanded')) {
                    archiveDescription.style.display = '-webkit-box';
                    archiveDescription.style.webkitLineClamp = maxLines;
                    archiveDescriptionShowMoreText.textContent = 'Leggi meno';
                } else {
                    archiveDescription.style.display = 'block';
                    archiveDescription.style.webkitLineClamp = 'unset';
                    archiveDescriptionShowMoreText.textContent = 'Leggi di più';
                }

                archiveDescription.classList.toggle('expanded');
                archiveDescriptionShowMore.classList.toggle('expanded');
            });
        }


        /*
        * ARCHIVE FIRST LEVEL CATEGORY SLIDER
        */
        let archiveFirstLevelCategorySlider = document.querySelector('.first-level-category-slider');
        if (archiveFirstLevelCategorySlider) {
            new Glider(archiveFirstLevelCategorySlider, {
                // Mobile-first defaults
                slidesToShow: 1.5,
                slidesToScroll: 1,
                scrollLock: true,
                arrows: {
                    prev: '.glider-prev',
                    next: '.glider-next'
                },
                responsive: [
                    {
                        // screens greater than >= 775px
                        breakpoint: 768,
                        settings: {
                            // Set to `auto` and provide item width to adjust to viewport
                            slidesToShow: 2.5,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.25
                        }
                    },{
                        // screens greater than >= 1024px
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.25
                        }
                    },{
                        // screens greater than >= 1024px
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.25
                        }
                    }
                ]
            });
        }


        /*
        * ARCHIVE SECOND LEVEL CATEGORY SLIDER
        */
        let archiveSecondLevelCategorySlider = document.querySelector('.second-level-category-slider');
        if (archiveSecondLevelCategorySlider) {
            new Glider(archiveSecondLevelCategorySlider, {
                // Mobile-first defaults
                slidesToShow: 1.5,
                slidesToScroll: 1,
                scrollLock: true,
                arrows: {
                    prev: '.glider-prev',
                    next: '.glider-next'
                },
                responsive: [
                    {
                        // screens greater than >= 775px
                        breakpoint: 768,
                        settings: {
                            // Set to `auto` and provide item width to adjust to viewport
                            slidesToShow: 2.5,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.25
                        }
                    },{
                        // screens greater than >= 1024px
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.25
                        }
                    },{
                        // screens greater than >= 1024px
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                            itemWidth: 150,
                            duration: 0.25
                        }
                    }
                ]
            });
        }
    });
})

//handle menu opening
// document.addEventListener("DOMContentLoaded", () => {
//    const ProdottiMenulink = document.querySelector('#prodotti-menu-toggler');
//    const subMenuWrapper = document.querySelector('.container-fluid.submenu-wrapper');
//
//    if(ProdottiMenulink){
//        ProdottiMenulink.addEventListener('click', e => {
//            e.preventDefault();
//
//            if(subMenuWrapper.classList.contains('open')){
//                subMenuWrapper.classList.remove('open')
//            }else{
//                subMenuWrapper.classList.add('open')
//            }
//
//        })
//    }
// })

const mobileQuery = window.matchMedia('(max-width: 768px)');

// handle the header show/hide
document.addEventListener("DOMContentLoaded", () => {
    let lastScrollTop = 0;
    let scrollTimeout;
    document.body.classList.add('top-page-no-scroll');

    window.addEventListener('scroll', function() {

        // Aggiungi la classe "is-scrolling" quando l'utente scorre
        document.body.classList.add('is-scrolling');

        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScrollTop === 0) {
            // L'utente è in cima alla pagina
            document.body.classList.add('top-page-no-scroll');
            document.body.classList.remove('top-page-scrolled');
        } else {
            // L'utente non è in cima alla pagina
            document.body.classList.remove('top-page-no-scroll');
            document.body.classList.add('top-page-scrolled');

        }

        // Aggiorna la posizione di scroll
        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Previene un valore negativo

        // Cancella il timeout precedente
        clearTimeout(scrollTimeout);

        // Rimuove la classe "is-scrolling" dopo 200ms dall'ultimo scroll
        scrollTimeout = setTimeout(() => {
            document.body.classList.remove('is-scrolling');
        }, 200);
    });
});


//handle the submenu change menu
document.addEventListener("DOMContentLoaded", () => {
    const submenuCategories = document.querySelectorAll('div#v-pills-tab button.nav-link');
    if (submenuCategories) {
        submenuCategories.forEach(el => {
            let hoverTimeout;

            el.addEventListener('mouseenter', () => {
                // Inizia il timeout quando il mouse entra nell'elemento
                hoverTimeout = setTimeout(() => {
                    el.click(); // Triggera il click se l'utente rimane sull'elemento per 200ms
                }, 350);
            });

            el.addEventListener('mouseleave', () => {
                // Cancella il timeout se il mouse lascia l'elemento prima dei 200ms
                clearTimeout(hoverTimeout);
            });
        });
    }
})


// mananage first level menu click on desktop
const firstLevelMenu = document.querySelectorAll('.dropdown.has-mega-menu .dropdown-menu.depth_0.show li.menu-item-has-children a.dropdown-item.dropdown-toggle')
if(!mobileQuery.matches){
    if(firstLevelMenu){
        firstLevelMenu.forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                window.location.href = e.target.href;
            })
        })
    }
}


// handle the opening/closing of the submenu
document.addEventListener("DOMContentLoaded", () => {
    // Seleziona gli elementi
    const h6 = document.querySelector('h6#prodotti-menu-toggler');
    const h6Icon = document.querySelector('h6#prodotti-menu-toggler i');
    const mobileMenuToggler = document.querySelector('button#mobile-menu-toggler');
    const mobileMenuTogglerSvg = document.querySelector('button#mobile-menu-toggler svg');
    const mobileMenuTogglerPath = document.querySelector('button#mobile-menu-toggler svg path');
    const closeMobileMenu = document.querySelectorAll('h5 i.icon-x.close-menu');
    const submenu = document.querySelector('.container-fluid.submenu-wrapper');
    const header = document.querySelector('header.header');

    // Funzione per aprire il submenu
    function openSubmenu() {
        submenu.classList.add('open');
        header.classList.add('is-sebmenu-open');
        document.body.classList.add('menu-is-opened');
    }

    // Funzione per chiudere il submenu
    function closeSubmenu() {
        submenu.classList.remove('open');
        header.classList.remove('is-sebmenu-open');
        document.body.classList.remove('menu-is-opened');
    }

    // Funzione per gestire il click fuori dal menu
    function handleOutsideClick(event) {
        if (!submenu.contains(event.target) && event.target !== h6 && event.target !== h6Icon && event.target !== mobileMenuToggler && event.target !== mobileMenuTogglerSvg && event.target !== mobileMenuTogglerPath) {
            closeSubmenu();
        }
    }

    // Aggiungi l'evento di click sul pulsante h6 per aprire/chiudere il menu
    h6.addEventListener('click', (e) => {
        if (submenu.classList.contains('open')) {
            closeSubmenu();
        } else {
            openSubmenu();
        }
    });

    // Aggiungi l'evento di click sul pulsante mobileMenuToggler
    mobileMenuToggler.addEventListener('click', (event) => {
        if (submenu.classList.contains('open')) {
            closeSubmenu();
        } else {
            openSubmenu();
        }
    });

    // Aggiungi l'evento di click sui pulsanti di chiusura
    closeMobileMenu.forEach(el => {
        el.addEventListener('click', closeSubmenu);
    });


    // Aggiungi l'evento di click al documento per chiudere il menu cliccando fuori
    document.addEventListener('click', handleOutsideClick);
});

//handle mobile tabs opening
document.addEventListener("DOMContentLoaded", () => {
  const categoryLinks = document.querySelectorAll('div#v-pills-tab button.nav-link');
  const contentTabWrapper = document.querySelector('div#v-pills-tabContent');
  const closeContentButton = document.querySelectorAll('h5 i.icon-x.depth-0');
  const backToCategoryButton = document.querySelectorAll('i.icon-left.depth-0');

  if(categoryLinks){
      categoryLinks.forEach(el => {
          el.addEventListener('click', e => {
              contentTabWrapper.classList.add('open')
          })
      })
  }

  if(closeContentButton){
      closeContentButton.forEach(el => {
          el.addEventListener('click', e => {
              contentTabWrapper.classList.remove('open')
          })
      })
  }

  if(backToCategoryButton){
      backToCategoryButton.forEach(el => {
          el.addEventListener('click', e => {
              if(e.target.dataset.submenu === 'false'){
                  contentTabWrapper.classList.remove('open')
              }
          })
      })
  }




});

//handle 3rd level mobile menu
document.addEventListener("DOMContentLoaded", () => {
    const subCategories = document.querySelectorAll('div#v-pills-tabContent a.dropdown-item.dropdown-toggle');
    const categoryParent = document.querySelectorAll('div#v-pills-tabContent h5.mobile-top-title');

    if(subCategories){
        subCategories.forEach(el => {
            el.addEventListener('click', e => {
                let subCatText = e.target.textContent
                let subCatParent = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling;

                let parentCat = subCatParent.querySelector('h5.mobile-top-title')
                let parentCatText = parentCat.textContent;

                let parentCatBack = subCatParent.querySelector('i.icon-left.depth-0')
                parentCatBack.dataset.submenu = true;

                parentCat.textContent = subCatText;
                parentCat.dataset.parentName = parentCatText;
            });
        });
    }

    const backTogglers = document.querySelectorAll('div#v-pills-tabContent i.icon-left.depth-0');
    if(backTogglers){
        backTogglers.forEach(el => {
            el.addEventListener('click', e => {
                if(e.target.dataset.submenu === 'true'){
                  let childMenuWrapper = e.target.parentElement.nextElementSibling;
                  let childMenu = childMenuWrapper.querySelector('ul.dropdown-menu.sub-menu.depth_1.show')
                  let parentName = e.target.nextElementSibling;
                  let parentNameText = parentName.dataset.parentName;
                    childMenu.classList.remove('show')
                    e.target.dataset.submenu = false;
                    parentName.textContent = parentNameText;
                    parentName.dataset.parentName = ''
                }
            })
        })
    }

});


//manage update quantity handler in single product.
document.addEventListener("click", event => {
    //minus
    if (event.target.matches("form.cart .perf-quantity-button.minus")) {
        removeMinusQuantity(event, true);
    }
    //plus
    if (event.target.matches("form.cart .perf-quantity-button.plus")) {
        addPlusQuantity(event, false);
    }

});

//manage min max input on single product
document.addEventListener("DOMContentLoaded", () => {

    const productInput = document.querySelector('body.single-product .summary form.cart .qty');
    if(productInput){
        productInput.addEventListener('keyup', (event)=> {
            let val = parseFloat(event.target.value);
            let max = parseFloat(event.target.getAttribute('max'));
            let min = parseFloat(event.target.getAttribute('min'));

            if(val <= min){
                event.target.value = min;
            }
            if(val > max){
                event.target.value = max;
            }
            manageMaxStock(event.target.value, max)
        })
    }

})


//set quantity input when minus button is clicked
function removeMinusQuantity(event, isBottomBar) {
    const element = event.target;

    const quantityInput = event.target.parentElement.nextElementSibling.nextElementSibling;

    const inputName = quantityInput.name;
    const regex = /cart\[(.*?)\]\[qty\]/;
    const match = inputName.match(regex);

    var cartItemKey = '';
    if(match){
        cartItemKey = match[1];
    }

    //get data of quantity
    let val = parseFloat(quantityInput.value);
    let max = parseFloat(quantityInput.getAttribute('max'));
    let min = parseFloat(quantityInput.getAttribute('min'));
    let step = parseFloat(quantityInput.getAttribute('step'));

    if((val - 1 ) > 0){
        quantityInput.value = val - step;
    }

    manageMaxStock(quantityInput.value, max)

    //use jquery call to enable update button
    const qtyJ = jQuery( element ).parent( '.quantity' ).find( '.qty' );
    qtyJ.change();

};
//set quantity input when plus button is clicked
function addPlusQuantity (event, isBottomBar) {
    const element = event.target;

    const quantityInput = event.target.parentElement.previousElementSibling;

    const inputName = quantityInput.name;
    const regex = /cart\[(.*?)\]\[qty\]/;
    const match = inputName.match(regex);
    var cartItemKey = '';
    if(match){
        cartItemKey = match[1];
    }

    //get data of quantity
    let val = parseFloat(quantityInput.value);
    let maxAttr = quantityInput.getAttribute('max');
    let max = maxAttr !== null && maxAttr.trim() !== '' ? parseFloat(maxAttr) : null;
    let minAttr = quantityInput.getAttribute('min');
    let min = minAttr !== null && minAttr.trim() !== '' ? parseFloat(minAttr) : null;
    let step = parseFloat(quantityInput.getAttribute('step')) || 1;

    // Se non è presente un valore massimo, consenti incremento illimitato
    if (max === null || isNaN(max)) {
        quantityInput.value = val + step;
    } else {
        // Se il nuovo valore non supera il massimo, incrementa
        if ((val + step) <= max) {
            quantityInput.value = val + step;
        }
    }
    manageMaxStock(quantityInput.value, max);
    //use jquery call to enable update button
    const qtyJ = jQuery( element ).parent( '.quantity' ).find( '.qty' );
    qtyJ.change();
}

function manageMaxStock(val, max){
    let maxMessagge = document.querySelector('p.perf-max-stock-info');

    if(parseInt(val) < max || (max === null || isNaN(max))){
        if (maxMessagge) {
            maxMessagge.remove()
        }
    }

    if(!(max === null || isNaN(max)) && parseInt(val) === max){
        if(!maxMessagge){
            let p = document.createElement('p');
            p.classList.add('text-danger', 'perf-max-stock-info');
            p.innerHTML = 'Quantità massima raggiunta';
            setTimeout(() => {
                document.querySelector('form.cart').appendChild(p)
            }, 100);
        }
    }

}


/*!
 * jQuery Collapsable Breadcrumbs
 * Original author: jyoakum@siteworx.com
 * Depends on scss structure.  No inline styles.
 */
;
(function($, window, document, undefined) {
    // Create the defaults once
    var pluginName = 'perf-breadcrumb',
        pluginCssBlock = '.' + pluginName,
        cssExpanded = pluginName + '_expanded',
        cssToggle = pluginName + '__toggle',
        cssOverflow = pluginName + '_overflow',
        defaults = {
            /*propertyName: "value"*/
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype = {

        init: function() {
            this.injectExpander(this.$element);
            this.checkOverflow();
            var self = this;

            var lazyResize = $.proxy(this.debounce(this.checkOverflow, 300), self);
            var lazyToggle = $.proxy(this.doToggle, self);
            this.$element.on('click.' + pluginName, '.' + cssToggle, lazyToggle);
            $(window).on('resize.' + pluginName, lazyResize);
        },

        isOverflowed: function(el) {
            // Determins if we have overflow
            return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
        },

        checkOverflow: function() {
            if (this.isOverflowed(this.element)) {
                this.$element.addClass(cssOverflow);
            } else {
                this.$element.removeClass(cssOverflow);
                // double check to make sure that that toggle is still valid
                if (this.isOverflowed(this.element)) {
                    this.$element.addClass(cssOverflow);
                }
            }
        },

        doCollapse: function() {
            this.$element
                .addClass(cssExpanded);
        },

        doExpand: function() {
            this.$element
                .removeClass(cssExpanded);
        },

        doToggle: function(evt) {
            evt.preventDefault();
            var $el = this.$element;

            if ($el.hasClass(cssExpanded)) {
                this.doExpand();
            } else {
                this.doCollapse();
            }

        },

        injectExpander: function($el) {
            if (!$el.has(cssToggle).length) {
                $el
                    .children(':first')
                    .after($('<span class="' + cssToggle + '"><a href="#"></a></span>'));
            }
        },

        debounce: function(func, wait, immediate) {
            var timeout, args, context, timestamp, result;

            var now = Date.now || function() {
                return new Date().getTime();
            };

            var later = function() {
                var last = now() - timestamp;

                if (last < wait && last >= 0) {
                    timeout = setTimeout(later, wait - last);
                } else {
                    timeout = null;
                    if (!immediate) {
                        result = func.apply(context, args);
                        if (!timeout) context = args = null;
                    }
                }
            };

            return function() {
                context = this;
                args = arguments;
                timestamp = now();
                var callNow = immediate && !timeout;
                if (!timeout) timeout = setTimeout(later, wait);
                if (callNow) {
                    result = func.apply(context, args);
                    context = args = null;
                }

                return result;
            };
        }
    };

    $.fn[pluginName] = function(options) {
        return this.each(function() {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    };

    // AutoInit based on predefined class (.breadcrumbs). Remove if you don't want this
    $(document).ready(function() {
        $(pluginCssBlock)[pluginName]();
    });

})(jQuery, window, document);

//login page logic
document.addEventListener('DOMContentLoaded', function () {

    //step login in checkout
    const logButton = document.querySelector('#step-login-1 .base-login .perf-login-next-step');
    if (logButton) {
        //when click on login button hide step 1 and show step 2
        logButton.addEventListener('click', function (e) {
            e.preventDefault();
            const step1 = document.querySelector('.step-1-row');
            step1.style.display = 'none';
            // step1.classList.add('hidden-step');
            const step2 = document.querySelector('.step-2-row');
            // step2.style.display = 'block';

            step2.classList.add('slide-up');
            step2.classList.remove('hidden-step');
        })
    }




    const backButton = document.querySelector('.perf-step-back');
    if (backButton) {
        //when click on back button hide step 2 and show step 1
        backButton.addEventListener('click', function (e) {
            e.preventDefault();
            const step1 = document.querySelector('.step-1-row');

            step1.style.display = 'flex';
            const step2 = document.querySelector('.step-2-row');
            // step2.style.display = 'block';
            step2.classList.remove('slide-up');
            // step2.classList.add('hidden-step');
        })
    }





})

//minicart ajax update price quantity
document.addEventListener('DOMContentLoaded', function (){
    let timeoutId; // timeout per aggiornameto ajax nel carrello
    var formAction;

    //manage update quantity handler in cart page.;
    document.addEventListener("click", event => {

        //minus handler
        if (event.target.matches("div#offcanvasCart .perf-mini-cart-item-details-bottom .perf-quantity-button.minus")) {
            removeMinusCart(event);
        }
        //plus handler
        if (event.target.matches("div#offcanvasCart .perf-mini-cart-item-details-bottom .perf-quantity-button.plus")) {
            addPlusCart(event);
        }

    });


    document.addEventListener("keyup", event => {

        let keyCode = event.keyCode || event.which;

        // Verifica se il codice corrisponde a un numero (0-9)
        // if (keyCode >= 48 && keyCode <= 57) {
        if ((keyCode >= 48 && keyCode <= 57) || keyCode === 8 || keyCode === 46) {
            // Numeri nella tastiera principale (0-9)
            if (event.target.matches("div#offcanvasCart .perf-mini-cart-item-details-bottom .quantity .qty")) {
                const cartKey = event.target.parentElement.parentElement.parentElement.previousElementSibling.lastElementChild.firstElementChild.dataset.cart_item_key;
                console.log(event.target.value)

                let val = parseFloat(event.target.value);
                let max = parseFloat(event.target.getAttribute('max'));
                let min = parseFloat(event.target.getAttribute('min'));

                if(event.target.value.length > 0){
                    clearTimeout(timeoutId); // Cancella il timeout attuale se presente
                    if(val < min){
                        event.target.value = min;
                    }
                    if(val > max){
                        event.target.value = max;
                    }
                    timeoutId = setTimeout(function() {
                        updateInputQuantity(event.target.value, cartKey, 'minicart');
                    }, 400);
                }else{
                    clearTimeout(timeoutId); // Cancella il timeout attuale se presente
                }
            }

        } else if ((keyCode >= 96 && keyCode <= 105) || keyCode === 8 || keyCode === 46) {
            // Numeri nel tastierino numerico (0-9)
            if (event.target.matches("div#offcanvasCart .perf-mini-cart-item-details-bottom .quantity .qty")) {
                const cartKey = event.target.parentElement.parentElement.parentElement.previousElementSibling.lastElementChild.firstElementChild.dataset.cart_item_key
                console.log(event.target.value)

                let val = parseFloat(event.target.value);
                let max = parseFloat(event.target.getAttribute('max'));
                let min = parseFloat(event.target.getAttribute('min'));

                if(event.target.value.length > 0){
                    clearTimeout(timeoutId); // Cancella il timeout attuale se presente
                    if(val < min){
                        event.target.value = min;
                    }
                    if(val > max){
                        event.target.value = max;
                    }
                    timeoutId = setTimeout(function() {
                        updateInputQuantity(event.target.value, cartKey, 'minicart');
                    }, 400);
                }else{
                    clearTimeout(timeoutId); // Cancella il timeout attuale se presente
                }
            }

        }


    });

    function updateInputQuantity(qty, cartKey, position) {

        let cart_item_key = cartKey;
        var spinnerContainer;

        if(position === 'cart'){
            spinnerContainer = document.querySelector('.spinner-container');
            spinnerContainer.classList.add('show');
        }else{
            spinnerContainer = document.querySelector('.spinner-container-minicart');
            spinnerContainer.classList.add('show');
        }

        // let cart_item_key = cart_item.replace('cart_', '');

        // jQuery('.woocommerce.widget_shopping_cart').addClass('open');
        jQuery.ajax({
            type: 'POST',
            url: perf_ajax_object.ajaxurl,
            data: {
                action: 'ajax_update_mini_cart',
                cart_item_key : cart_item_key,
                qty: qty

            }, // This must match the name of your wp_ajax filter
            success: function(response) {
                console.log('successo');
                console.log(response.data.minicart_body);
                // console.log(response.data['div.widget_shopping_cart_content']);
                // jQuery(document.body).trigger('wc_fragment_refresh');
                spinnerContainer.classList.remove('show');
                jQuery('div#offcanvasCart .offcanvas-body').html(response.data['minicart_body']);
                jQuery('header .top-header-icons span.cart-count-number').text(response.data['products_count']);
                // jQuery('.woocommerce-cart .cart-orders .cart-collaterals .cart-total-info .cart-total-title').html(response.data['total']);
                // jQuery('.woocommerce-cart .perf-bottom-cart-sticky-bar-wrapper .perf-bottom-cart-total').html(response.data['total']);
                // jQuery('.woocommerce-cart .cart-orders .cart-collaterals .cart-total-info .cart-total-subtotal').html(response.data['subtotal']);
                jQuery('.woocommerce-mini-cart__total.total').html('<strong>Subtotale:</strong>' + response.data.subtotal);
                // jQuery('.woocommerce .woocommerce-cart-form').html(response.data.cart_content);
                // jQuery('.woocommerce .notices-wrapper').html(response.data.cart_notice);
                const plusMiniCart = document.querySelectorAll('.widget_shopping_cart_content .perf-quantity-button.plus');
                for (const miniPlus of plusMiniCart) {
                    miniPlus.addEventListener('click', addPlusMini);
                }

                const minusMiniCart = document.querySelectorAll('.widget_shopping_cart_content .quantity .perf-quantity-button.minus');
                for (const miniMinus of minusMiniCart) {
                    miniMinus.addEventListener('click', removeMinusMini);
                }

            }
        });
    };

    function removeMinusCart(event) {
        //get element target
        const element = event.target;

        const quantityInput = event.target.parentElement.nextElementSibling.nextElementSibling;

        const inputName = quantityInput.name;
        const regex = /cart\[(.*?)\]\[qty\]/;
        const match = inputName.match(regex);

        // const cartKey = event.target.parentElement.parentElement.parentElement.previousElementSibling.lastElementChild.firstElementChild.dataset.cart_item_key;
        const cartKey = event.target.parentElement.parentElement.parentElement.parentElement.previousElementSibling.lastElementChild.firstElementChild.dataset.cart_item_key;

        //get data of quantity
        let val = parseFloat(quantityInput.value);
        let max = parseFloat(quantityInput.getAttribute('max'));
        let min = parseFloat(quantityInput.getAttribute('min'));
        let step = parseFloat(quantityInput.getAttribute('step'));

        if((val - 1 ) >= 0){
            quantityInput.value = val - step;
        }
        //use jquery call to enable update button
        const qtyJ = jQuery( element ).parent( '.quantity' ).find( '.qty' );
        qtyJ.change();



        clearTimeout(timeoutId); // Cancella il timeout attuale se presente
        timeoutId = setTimeout(function() {
            updateInputQuantity(quantityInput.value, cartKey, 'minicart');
        }, 400);

    }

    function addPlusCart(event) {
        //get element target
        const element = event.target;

        const quantityInput = event.target.parentElement.previousElementSibling;

        const inputName = quantityInput.name;
        const regex = /cart\[(.*?)\]\[qty\]/;
        const match = inputName.match(regex);
        const cartKey = event.target.parentElement.parentElement.parentElement.parentElement.previousElementSibling.lastElementChild.firstElementChild.dataset.cart_item_key;

        //get data of quantity
        let val = parseFloat(quantityInput.value);
        let max = parseFloat(quantityInput.getAttribute('max'));
        let min = parseFloat(quantityInput.getAttribute('min'));
        let step = parseFloat(quantityInput.getAttribute('step'));

        //Check if value is max
        // if (max && (max <= val)) {
        //   qty.value = max;
        // } else {
        //   qty.value = val + step;
        // }
        if(isNaN(max)){
            quantityInput.value = val + step;
        }else{
            if((val + 1) <= max){
                quantityInput.value = val + step;
            }
        }


        //use jquery call to enable update button
        const qtyJ = jQuery( element ).parent( '.quantity' ).find( '.qty' );
        qtyJ.change();

            clearTimeout(timeoutId); // Cancella il timeout attuale se presente
            timeoutId = setTimeout(function() {
                updateInputQuantity(quantityInput.value, cartKey, 'minicart');
            }, 400);

    }



});

//manage perf filter grid columns
document.addEventListener('DOMContentLoaded', function (){
    let $searchFilter = jQuery('#performize-filter');
    if($searchFilter.hasClass('modal')) {
        $searchFilter.on('show.bs.modal', onModalShow);
    }

    function onModalShow(){
        let numColumns = Object.keys(filter_settings.available_taxonomies).length;
        jQuery('#performize-filter #performize-filter-form .accordion-grid').css(
            'grid-template-columns',
            `repeat(${numColumns}, 1fr)`
        );
    }
});


/* manage update cart counter */
document.addEventListener("DOMContentLoaded", function() {
    jQuery('body').on('added_to_cart',function() {
        jQuery.ajax({
            type: 'POST',
            url: perf_ajax_object.ajaxurl,
            data: {
                action: 'ajax_fragment_mini_cart',
            }, // This must match the name of your wp_ajax filter
            success: function(response) {
                jQuery('div#offcanvasCart .offcanvas-body').html(response.data['minicart_body']);
                jQuery('header .top-header-icons span.cart-count-number').text(response.data['products_count']);
                jQuery('.woocommerce-mini-cart__total.total').html('<strong>Subtotale:</strong>' + response.data.subtotal);
            }
        });
    });
});

//manage delete product from minicart
document.addEventListener("DOMContentLoaded", function() {
    jQuery(document.body).on('removed_from_cart', function (event, fragments, cart_hash, button) {
        jQuery.ajax({
            type: 'POST',
            url: perf_ajax_object.ajaxurl,
            data: {
                action: 'ajax_fragment_mini_cart',
            }, // This must match the name of your wp_ajax filter
            success: function(response) {
                jQuery('div#offcanvasCart .offcanvas-body').html(response.data['minicart_body']);
                jQuery('header .top-header-icons span.cart-count-number').text(response.data['products_count']);
                jQuery('.woocommerce-mini-cart__total.total').html('<strong>Subtotale:</strong>' + response.data.subtotal);
            }
        });
    });
})
